import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { AdminService } from '../services/admin.service';
import { InsertAdminEmpresaRequest } from '../requests/insert-empresa-admin-request';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-adm-empresa-nueva',
  templateUrl: './adm-empresa-nueva.component.html',
  styleUrls: ['./adm-empresa-nueva.component.css']
})
export class AdmEmpresaNuevaComponent implements OnInit {

  addEmpresaForm: FormGroup;

  usernameValidated = false;
  actualUsername = '';

  constructor(private formBuilder: FormBuilder,
              private toast : ToastrService,
              private adminService : AdminService) 
  {}

  ngOnInit() {

    this.addEmpresaForm = this.formBuilder.group({
      companyName: new FormControl('', [Validators.required,
                                  Validators.minLength(3),
                                  Validators.maxLength(100)]),
      responsableName: new FormControl('', [Validators.required,
                                  Validators.minLength(6),
                                  Validators.maxLength(85)]),
      responsableMail: new FormControl('', [Validators.minLength(8),
                                  Validators.maxLength(85),
                                Validators.email]),
      username: new FormControl('', [Validators.required,
                                      Validators.pattern(/^[^\sñ]+$/),
                                      Validators.maxLength(15),
                                      Validators.minLength(5),
                                      Validators.pattern(/^[a-zA-Z0-9]+$/)
                                    ]),
      isActivated: new FormControl(true, [Validators.required]),
    });
  }

  trySubmit()
  {
    if(this.addEmpresaForm.invalid || !this.usernameValidated)
    {
      this.toast.error('Verifique la información','error');
      return;
    }
    try {
      // assign values
      let request = {} as InsertAdminEmpresaRequest;
      request.nombreEmpresa = this.f.companyName.value;
      request.nombreResponsable = this.f.responsableName.value;
      request.usuario = this.f.username.value;
      request.requireValidation = !this.f.isActivated.value;
      request.password = request.usuario;
      request.email = this.f.responsableMail.value;

      this.adminService.agregarEmpresa(request).subscribe({
        next: (result) => 
        {
          if(result.idEmpresa>0)
            this.toast.success(result.message,'');
          else
            this.toast.error(result.message,'');
        },
        error: (error) => {
          this.toast.error('Ocurrio un error con el servidor','error');
        },
        complete: () => 
        {
          this.addEmpresaForm.reset();
          this.f.isActivated.setValue(true);
          this.actualUsername = '';
          this.usernameValidated = false;
        }
    });
    } catch (error) {
      this.toast.error('Ocurrio un error con el servidor','error');
    }
  }

  
  get f() {
    return this.addEmpresaForm.controls;
  }

  async validateUsername() : Promise<void>
  {
    try {
      var result = await firstValueFrom(this.adminService.validarUsuario(this.f.username.value));
      if(result===2)
      {
        this.toast.success('Usuario disponible','');
        this.actualUsername = this.f.username.value;
        this.usernameValidated=true;
        return;
      }
      this.toast.error('El usuario ya esta existe','');
      this.usernameValidated=false;
    } catch (error) {
      this.toast.error('Ocurrio un error con el servidor','error');
    }
  }

}